import React, { Component } from 'react'
import { connect } from 'react-redux'
import { switchTeamsInfo } from '../../../actions'
// import { getActivePlayers } from '../../../actions'

class TeamsStats extends Component {
  render () {
    const { teams, players } = this.props
    const complete = teams.filter(t => t.complete)
    const incomplete = teams.filter(t => !t.complete)
    const active = teams.filter(t => {
      const teammates = t.participants.map(p => players.find(pl => pl.id === p))
      return teammates.filter(p => p && p.attending_status === 'invited').length === 0
    })
    const inactive = teams.filter(t => {
      const teammates = t.participants.map(p => players.find(pl => pl.id === p))
      return teammates.filter(p => p && p.attending_status === 'invited').length > 0
    })
    const withNotActivatedTeammates = teams.filter(t => {
      const teammates = t.participants.map(p => players.find(pl => pl.id === p))
      return teammates.findIndex(p => p === undefined) > -1
    })

    return [
      <div className='dashboard-teams-row' key='0'>
        <div className='cell-subject'>-----------------------</div>
      </div>,
      <div className='dashboard-teams-row' key='1'>
        <div className='cell-subject'>Teams</div>
        <div className='cell-tags cell-looking-for'>
          {teams.length}
        </div>
      </div>,
      <div className='dashboard-teams-row' key='2' >
        <div className='cell-subject unset-text-transform'>Complete</div>
        <div className='cell-tags cell-looking-for'>
          {complete.length}
        </div>
      </div>,
      <div className='dashboard-teams-row' key='3' >
        <div className='cell-subject unset-text-transform'>Incomplete</div>
        <div className='cell-tags cell-looking-for'>
          {incomplete.length}
        </div>
      </div>,
      <div className='dashboard-teams-row' key='4' >
        <div className='cell-subject unset-text-transform'>With active players</div>
        <div className='cell-tags cell-looking-for'>
          {active.length}
        </div>
      </div>,
      <div className='dashboard-teams-row' key='5' >
        <div className='cell-subject unset-text-transform'>With inactive players</div>
        <div className='cell-tags cell-looking-for'>
          {inactive.length}
        </div>
        <div className='cell-team admin-tab-cell'>
          <button
            onClick={() => this.props.dispatch(switchTeamsInfo({ teams: inactive, definition: 'Inactive' }))}
            className='button button-sm'>Info</button>
        </div>
      </div>,
      <div className='dashboard-teams-row' key='6' >
        <div className='cell-subject unset-text-transform'>With nonactivated players</div>
        <div className='cell-tags cell-looking-for'>
          {withNotActivatedTeammates.length}
        </div>
      </div>
    ]
  }
}

const mapStateToProps = (state) => {
  return {
    teams: state.team.teams,
    players: state.participants
  }
}

export default connect(mapStateToProps)(TeamsStats)



// WEBPACK FOOTER //
// ./src/screens/administration/statistics/TeamsStats.js